import api from "../../index";

export const GetClientDashboard = () => api.post("client-dashboard");
export const GetBannerDashboard = () => api.post("bannerlist");
export const SubmitSignatureApi = (data, headers) => api.post('signature-submit', data, headers);
